import React from "react";
import { Button } from "react-bootstrap";

const styleButton = "";
export default function ButtonWithIcon({iconPosition, label, icon, className, variant ,onClick,...props}) {
  return (
    <div className="flex-nowrap d-flex">
      <style type="text/css">
        {`
    .btn-light {
      color: #1f7e78;
      background-color: #E3ECED!important;
      fontWeight: bolder!important;
    }

  //   .btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
  //     background-color: #E3ECED!important;
  //     border:none!important;
  // }
    .btn-outline-primary {
      color: #1f7e78;
    }
    .btn-link {
      color:black;
    }
    .btn-link:hover {
      color: #1f7e78;
    }
    `}
      </style>
      <Button
        variant={variant}
        className={`d-flex flex-row flex-nowrap  gap-1 align-items-center w-auto ${className}`}
        size="sm"
        onClick={onClick}
        {...props}
      >
        {iconPosition === "left" || !iconPosition && <span className="d-flex">{icon} </span>}
        <span className="">{label} </span>
        {iconPosition === "right" && <span className="d-flex">{icon} </span>}
      </Button>
    </div>
  );
}
